import { ProfilePublicationsAnswerType } from 'redux/actions/feedActions';
import { SubscribePayloadType } from 'redux/actions/followersActions';
import i18n from 'shared/i18n';
import { ChatUserStatus } from 'types/chatsType';
import { ClsItem } from 'types/clsType';
import { FileDescriptor } from 'types/fileTypes';
import { ActionType, PayloadErrorType } from 'types/reduxTypes';
import { ForeignUserStoreType } from 'types/stateTypes';
import {
  CLEAR_USER_DATA,
  REQUEST_POSTS_BY_OWNER_SUCCESS,
  REQUEST_USER,
  REQUEST_USER_FAILED,
  REQUEST_USER_SUCCESS,
  SUBSCRIBE_SUCCESS,
} from '../constants';

const initialState: ForeignUserStoreType = {
  error: false,
  errorText: '',
  hasMorePublications: false,
  loading: false,
  publications: [],
  status: {
    isOnline: false,
    lastSeen: null,
  },
  userInfo: {
    addresses: [],
    authors: [],
    bannerUrl: null,
    birthDate: null,
    blocked: false,
    contactData: [],
    dsc: null,
    education: [],
    email: '',
    firstName: i18n.t('name'),
    fullName: '',
    gender: null,
    genderItem: {} as ClsItem,
    id: '',
    image: {} as FileDescriptor,
    imageUrl: '',
    keywordsMap: {},
    laborActivities: [],
    laborActivityCurrentPosition: null,
    lastName: i18n.t('last.name'),
    meta: {
      subscn_count: 0,
      subscr_count: 0,
    },
    mutualStates: null,
    nickname: '',
    phone: '',
    placeOfBirth: '',
    placeOfResidence: '',
    settings: {},
    uref: '',
    userScientificInterests: [],
  },
};

export type ForeignUserAnswerType = {
  data: ForeignUserStoreType['userInfo'];
  isOwnProfile: boolean;
  status: ChatUserStatus;
};

export type ForeignUserPayloadType =
  | ForeignUserStoreType
  | ForeignUserAnswerType
  | SubscribePayloadType
  | ProfilePublicationsAnswerType
  | PayloadErrorType;

export const subscription = '132:18';

export default (state = initialState, action: ActionType<ForeignUserPayloadType>): typeof initialState => {
  switch (action.type) {
    case REQUEST_USER: {
      return { ...state, loading: true };
    }
    case REQUEST_USER_FAILED: {
      const newState = { ...state, loading: false };
      return newState;
    }
    case REQUEST_USER_SUCCESS: {
      const { data, isOwnProfile, status } = action.payload as ForeignUserAnswerType;
      const newState = {
        ...state,
        loading: false,
        status,
        userInfo: isOwnProfile ? { ...state.userInfo } : { ...state.userInfo, ...data },
      };
      return newState;
    }
    case SUBSCRIBE_SUCCESS: {
      const { isForeignProfile, subscribed } = action.payload as SubscribePayloadType;
      return isForeignProfile
        ? {
            ...state,
            userInfo: {
              ...state.userInfo,
              mutualStates: { ...state.userInfo.mutualStates, out: { [subscription]: Boolean(subscribed) } },
            },
          }
        : state;
    }
    case REQUEST_POSTS_BY_OWNER_SUCCESS: {
      const { publications, pageSize } = action.payload as unknown as ProfilePublicationsAnswerType;
      const currentNews = state.publications;
      const hasMorePublications = publications.length === pageSize;
      return { ...state, hasMorePublications, loading: false, publications: currentNews.concat(publications) };
    }
    case CLEAR_USER_DATA: {
      return initialState;
    }

    default: {
      return state;
    }
  }
};
